import React, { Component } from "react";
import styled from "styled-components";
import Form from 'react-bootstrap/Form';
import { LocationNumberConfirm } from "./../../pages/NewIncidentPage/LocationNumberConfirm";

const Wrapper = styled.div`
  position: relative;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0px 0px 20px 0px;
`;

const extractNumberOrZero = (value) => {
  if (value === undefined || value === null) return 0;
  const match = String(value).match(/\d+/); // busca la primera secuencia de dígitos
  return match ? Number(match[0]) : 0;
};


class SearchBox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value || "",
      filter: {
        street_number: "short_name",
        route: "long_name",
        locality: "long_name",
        administrative_area_level_2: "short_name",
        country: "long_name",
        postal_code: "short_name"
      },
      hasStreet: false,
      typingTimeout: 0,
      open: false,
      street_number: "",
      streetNumberForced: false,
      googleCantFindStreetNumber: false
    };
    this.clearSearchBox = this.clearSearchBox.bind(this);
  }

  componentDidMount({ map, mapApi } = this.props) {
    /*
    this.searchBox = new mapApi.places.SearchBox(this.searchInput);
    this.searchBox.addListener("places_changed", this.onPlacesChanged);
    */
    this.searchBox = new mapApi.places.Autocomplete(this.searchInput, {
      types: ["address"]
    });
    this.searchBox.addListener("place_changed", this.onPlacesChanged);
    this.searchBox.bindTo("bounds", map);

    if (this.searchInput && this.props.value) {
      this.searchInput.value = this.props.value;
    }
  }

  componentDidUpdate() {
    const v = this.props.value || "";

    // 1) Mantener el DOM alineado con Formik
    if (this.searchInput && this.searchInput.value !== v) {
      this.searchInput.value = v;
    }

    // 2) Mantener el state alineado con Formik (para el input controlado)
    if (this.state.value !== v) {
      this.setState({ value: v });
    }
  }

  componentWillUnmount({ mapApi } = this.props) {
    mapApi.event.clearInstanceListeners(this.searchInput);
  }

  handleTextInputChange = (e) => {
    e.preventDefault();
    const typed = e.target.value;

    this.setState({
      value: typed,
      hasStreet: false,
      street_number: "",
      streetNumberForced: false,
      googleCantFindStreetNumber: false,
      open: false
    });

    if (this.props.onSearchGecorStreet) {
      this.props.onSearchGecorStreet(typed, typed);
    }
  };

  handleSelectSuggest = (geocodedPrediction) => {
    const { filter } = this.state;
    const { address_components, geometry, formatted_address } = geocodedPrediction;

    let nextState = {
      streetName: formatted_address, // solo la calle
      street_number: "",
      value: formatted_address,
      hasStreet: false,
      streetNumberForced: false,
      googleCantFindStreetNumber: false,
      open: false,
      x: 0,
      y: 0,
    };

    if (geometry) {
      nextState.x = geometry.location.lat();
      nextState.y = geometry.location.lng();
    }

    let hasStreet = false;

    if (address_components) {
      for (let i = 0; i < address_components.length; i++) {
        const addressType = address_components[i].types[0];

        if (addressType === "street_number") {
          hasStreet = true;
          nextState.street_number = address_components[i][filter[addressType]];
          nextState.streetNumberForced = false;
        }
      }
    }

    nextState.hasStreet = hasStreet;

    if (!hasStreet) {
      // abrir modal si no hay número
      nextState.open = true;
      nextState.googleCantFindStreetNumber = true;
    }

    this.setState(nextState, () => {
      this.props.onSuccessLocation({
        streetName: nextState.streetName,
        street_number: nextState.street_number,
        value: nextState.value,
        hasStreet: nextState.hasStreet,
        x: nextState.x,
        y: nextState.y,
      });
    });
  };



  handleChange = name => event => {
    event.preventDefault();
    const v = event.target.value;
    // console.log("[SearchBox] handleChange:", name, event.target.value);
    if (name === "street_number") {
      const num = extractNumberOrZero(v); // ✅ convierte "6b" → 6, "abc" → 0
      this.setState({
        street_number: num,
        hasStreet: num > 0,
        googleCantFindStreetNumber: false,
        streetNumberForced: true
      });
      return;
    }
    this.setState({ [name]: v });
  };

  handleClose = (event) => {
    event.preventDefault();

    const num = extractNumberOrZero(this.state.street_number);

    // reconstruir la dirección con el número justo después de la calle
    const parts = (this.state.value ?? "").split(",");
    if (parts.length > 0) {
      parts[0] = `${parts[0].trim()}, ${num}`;
    }
    const fullAddressWithNumber = parts.join(", ").trim();

    // usar Google Geocoder para obtener lat/lng con el número incluido
    const geocoder = new this.props.mapApi.Geocoder();
    geocoder.geocode({ address: fullAddressWithNumber }, (results, status) => {
      if (status === this.props.mapApi.GeocoderStatus.OK && results[0]) {
        const geo = results[0].geometry.location;
        const nextState = {
          street_number: num,
          value: fullAddressWithNumber,
          hasStreet: num > 0,
          googleCantFindStreetNumber: false,
          open: false,
          streetNumberForced: true,
          x: geo.lat(),
          y: geo.lng(),
        };
        this.setState(nextState, () => {
          this.props.onSuccessLocation(nextState);
        });
      } else {
        // si falla el geocode, guardamos la dirección igual pero sin actualizar x,y
        this.setState(
          {
            street_number: num,
            value: fullAddressWithNumber,
            hasStreet: num > 0,
            googleCantFindStreetNumber: false,
            open: false,
            streetNumberForced: true,
          },
          () => {
            this.props.onSuccessLocation(this.state);
          }
        );
        console.error("[SearchBox] Geocode error:", status);
      }
    });
  };


  handleOpen = (open = true) => {
    this.setState({ open, street_number: open ? "" : this.state.street_number });
  };

  onPlacesChanged = () => {
    const { map, addplace, municipio, mapApi } = this.props;

    const place = this.searchBox.getPlace();
    //console.log("[SearchBox] onPlacesChanged - Autocomplete place:", place);

    if (!place || !place.geometry) return;

    const addressWithMunicipio = `${place.formatted_address}, ${municipio}`;
    //console.log(   "[SearchBox] onPlacesChanged - geocodificando con municipio:",addressWithMunicipio);

    const geocoder = new mapApi.Geocoder();

    geocoder.geocode({ address: addressWithMunicipio }, (results, status) => {
      //console.log("[SearchBox] Geocode results:", results, "Status:", status);

      if (status === mapApi.GeocoderStatus.OK && results[0]) {
        const geocodedPlace = results[0];

        if (!geocodedPlace.geometry) return;

        if (geocodedPlace.geometry.viewport) {
          map.fitBounds(geocodedPlace.geometry.viewport);
        } else {
          map.setCenter(geocodedPlace.geometry.location);
          map.setZoom(17);
        }

        this.handleSelectSuggest(geocodedPlace);
        addplace(geocodedPlace);
        this.searchInput.value = geocodedPlace.formatted_address;
        this.searchInput.blur();
      } else {
        console.error("[SearchBox] Geocode error:", status);
      }
    });
  };

  clearSearchBox() {
    if (this.searchInput && this.searchInput.value) return;

    this.searchInput.value = "";
    this.setState({
      value: "",
      hasStreet: false,
      street_number: ""
    });
  }

  render() {
    const { googleCantFindStreetNumber } = this.state;
    const { errors, touched, isSubmitting, t } = this.props;
    return (
      <Wrapper>
        <Form.Control
          s={12}
          icon="filter_3"
          placeholder={t("location.street-placeholder")}
          ref={ref => {
            this.searchInput = ref;
          }}
          value={this.state.value || ""}
          onChange={this.handleTextInputChange}
          onFocus={this.clearSearchBox}
          isInvalid={
            !!errors.streetName ||
            !!errors.streetOptions?.x ||
            !!errors.streetOptions?.y
          }
          isValid={
            touched.streetName &&
            !errors.streetName &&
            !errors.streetOptions?.x &&
            !errors.streetOptions?.y
          }
          disabled={isSubmitting}
        />
        <Form.Control.Feedback type="invalid">
          {errors.streetName}
          {!errors.streetName && errors.streetOptions?.x}
        </Form.Control.Feedback>

        <LocationNumberConfirm
          {...this.props}
          googleCantFindStreetNumber={googleCantFindStreetNumber}
          street_number={this.state.street_number}
          open={this.state.open}
          handleChange={this.handleChange("street_number")}
          handleClose={this.handleClose}
        />
      </Wrapper>
    );
  }
}

export default SearchBox;
